import React from 'react';
import Banner from './Banner';
import ScheduleTwo from './ScheduleTwo';
import ServicesTwo from './ServicesTwo';
import EventTwo from './EventTwo';
import CounterOne from './CounterOne';
import Brand from './Brand';
import ConferenceOne from './ConferenceOne';
import GalleryTwo from './GalleryTwo';
import Testimonial from './Testimonial';
import VideoOne from './VideoOne';
import TeamTwo from './TeamTwo';
import PricingOne from './PricingOne';
import BlogTwo from './BlogTwo';


const HomeTwoMain = () => {
	return (
		<>
		<Banner />
		<ScheduleTwo />
		<ServicesTwo />
		<EventTwo />
		<CounterOne />
		<Brand />
		<ConferenceOne />
		<GalleryTwo />
		<Testimonial />
		<VideoOne />
		<TeamTwo />
		<PricingOne />
		<BlogTwo />
		</>
	);
}

export default HomeTwoMain;
